// extracted by mini-css-extract-plugin
module.exports = {"singleLogo":"SingleLogo_singleLogo__c5VFS","singleLogo__nolink":"SingleLogo_singleLogo__nolink__inm6l"};